<ngx-datatable class="bootstrap" #dataTable [reorderable]="false" [headerHeight]="85" [footerHeight]="50"
  [limit]="rowLimit" [messages]="messages" [loadingIndicator]="isLoading" [columnMode]="columnMode.force"
  [rowHeight]="65" [rows]="data" [rowClass]="getRowClass">

  @if (isExpandable) {
    <ngx-datatable-row-detail #dataTableRow [rowHeight]="'auto'" [template]="detailTemplate">
    </ngx-datatable-row-detail>
    <ngx-datatable-column [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false"
      [maxWidth]="100">
      <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
        <div class="fas fa-fw" tabindex="1" [ngClass]="expanded ? 'fa-chevron-down':'fa-chevron-right'"
          (click)="toggleExpandRow(row)" (keydown)="toggleExpandRow(row)">
        </div>
      </ng-template>
    </ngx-datatable-column>
  }

  @for (column of columns; track column) {
    <ngx-datatable-column [prop]="column.prop" name="{{ column.label | translate }}">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value">
        @switch (column.show) {
          @case ('CHECK') {
            <em class="fas fa-fw" [ngClass]="value ? 'fa-check text-success' : 'fa-minus text-muted'"></em>
          }
          @case ('COUNTER') {
            @if (value.length; as count) {
              <span class="badge badge-warning badge-pill">{{ count }}</span>
            } @else {
              <em class="fas fa-fw fa-minus text-muted"></em>
            }
          }
          @case ('DATE') {
            <span class="">{{ value | amLocale:language | amDateFormat: 'LL' }}</span>
          }
          @case ('DATE-TIME') {
            <span class="">{{ value | amLocale:language | amDateFormat: 'LLL' }}</span>
          }
          @case ('MASKED') {
            <button type="button" class="btn btn-link px-2" ngxClipboard [cbContent]="value" tabindex="2"><em
            class="fas fa-clipboard"></em></button>
            <span class="" (click)="toggleMasked(rowIndex)" (keydown)="toggleMasked(rowIndex)" tabindex="3">{{
            showMasked === rowIndex ? value : '**********' }}</span>
          }
          @default {
            <span class="">{{value}}</span>
          }
        }
      </ng-template>
    </ngx-datatable-column>
  }

  @if (actions.length) {
    <ngx-datatable-column prop="actions" name="{{ 'actions' | translate }}" [sortable]="false" [maxWidth]="100">
      <ng-template ngx-datatable-cell-template let-row="row">
        <div class="text-center">
          @for (action of actions; track action.type) {
            <button class="btn btn-circle mr-2 btn-{{ action.btnClass }}"
              (click)="emitAction($event, action.type, row)" *accessControl="action.accessControl"
              [disabled]="action.isDisabled(row)">
              <em class="fas {{ action.icon }}"></em>
            </button>
          }
        </div>
      </ng-template>
    </ngx-datatable-column>
  }
</ngx-datatable>
